import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useModuleApi } from "../../../../shared/utils/use-module-api";
import { useAppDispatch } from "../../../../store";
import { addNotificationAction } from "../../../notifications";
import { NotificationSeverity } from "../../../notifications/shared/enums/notification-severity";
import { NotificationType } from "../../../notifications/shared/enums/notification-type";
import { getEnabled } from "../../store/verification.selector";
import {
  setEnabledAction,
  VERIFICATION_MODULE_NAME,
} from "../../store/verification.slice";
import { verificationService } from "../services/verification.service";

export function useVerification(): void {
  const dispatch = useAppDispatch();
  const enabled = useSelector(getEnabled);

  // INITIALIZATION
  useEffect(() => {
    // default verification handler
    verificationService.onError(
      (error, message = "Ответ сервера не валиден (см. консоль)") => {
        dispatch(
          addNotificationAction({
            type: NotificationType.Snack,
            severity: NotificationSeverity.Warning,
            message,
            error,
          })
        );
        console.warn(message, error);
      }
    );
  }, [dispatch]);

  // enable service
  useEffect(() => verificationService.enable(enabled), [enabled]);

  // extend context by api
  useModuleApi(VERIFICATION_MODULE_NAME, {
    enable: (value: boolean) => dispatch(setEnabledAction(value)),
  });
}
